import { useContext } from "react";
import { ThemeContext } from "~/contexts/themeContextValue";

export type Theme = "light" | "dark";

/**
 * Hook to access theme state and controls
 */
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
